var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markedown-document-content"},[_c('mavon-editor',{attrs:{"toolbars":_vm.toolbars,"editable":false,"toolbarsFlag":false,"subfield":false,"defaultOpen":_vm.preview},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }